import { HttpClient } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { LogInstanceToken, LogInterface } from '@evorait/pace-logging';
import { Observable, throwError } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { ENDPOINTS } from '../../enums/endpoints.enum';
import { OdataResponse } from '../../interfaces/online-only.interface';
import {
    InputFieldPropertyModel,
    ODataInputFieldPropertyModel,
} from '../../models/low-level/input-field-property.model';
import { UriUtilitiesService } from '../../services/uri-utilities/uri-utilities.service';
import { isDefined } from '../../utilities/is-defined';
import { ODataUtilities } from '../../utilities/odata-utilities';
import { UserMasterService } from '../user-master/user-master.service';
import { OdataInputFieldPropertiesServiceInterface } from './odata-input-field-properties.interface';

@Injectable({
    providedIn: 'root',
})
export class OdataInputFieldPropertiesService implements OdataInputFieldPropertiesServiceInterface {
    public constructor(
        @Inject(LogInstanceToken) private readonly log: LogInterface,
        private readonly uriUtilities: UriUtilitiesService,
        private readonly http: HttpClient,
        private readonly userMasterService: UserMasterService,
    ) {}

    public getInputFieldPropertySet(): Observable<InputFieldPropertyModel[]> {
        let query = this.userMasterService.setSalesOrgAndPlantForUrl(
            this.uriUtilities.getUriForContent() + ENDPOINTS.InputFieldProperties,
        );
        query = this.uriUtilities.appendParameter(query, '$format=json');

        return this.http.get<OdataResponse<ODataInputFieldPropertyModel>>(query).pipe(
            map((response) => {
                return ODataUtilities.transformResponseDataToArray(response.d)
                    .map((value: ODataInputFieldPropertyModel) => InputFieldPropertyModel.fromOData(value))
                    .filter(isDefined);
            }),
            catchError((err) => {
                this.log.error('getInputFieldPropertySet() - request error:  ' + JSON.stringify(err));
                return throwError(err);
            }),
        );
    }
}
